import SelectedTest from "Components/Cards/SelectedTest/SelectedTest";
import Footer from "Components/Footer/Footer";
import Header from "Components/Header/Header";
import React, { useEffect, useState } from "react";
import Calendar from "moedim";
import "./Cart.css";
import BackButton from "Components/BackButton/BackButton";
import { fetchSlotApi, fetchTheCartApi } from "API/get.api";
import { useDispatch, useSelector } from "react-redux";
import { setAlert } from "../../Redux/Actions/alert.action";
import moment from "moment-timezone";
import {
  setCartDataAction,
  setOrderId,
  setUserForTestTotalAmount,
} from "../../Redux/Actions/set.action";
import { proceedFromCart } from "API/post.api";
import { useNavigate } from "react-router-dom";

const CollectionLocation = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [timeSlotData, setTimeSlotData] = useState([]);
  const [timeSlotData2, setTimeSlotData2] = useState([]);

  const [inHouseSlotId, setinHouseSlotId] = useState("");
  const [outsourceSlotId, setoutsourceSlotId] = useState("");

  const [selectedId, setSelectedId] = useState("");
  const [selectedId2, setSelectedId2] = useState("");
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("access_token");
  const testList = useSelector((state) => state.setCartDataReducer?.tests);
  const tAmount = useSelector((state) => state.setCartTotalAmount);

  const home = testList?.home ? testList?.home : [];
  const lab = testList?.lab ? testList?.lab : [];

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page when component mounts
  }, []);

  let outSorcetotalData = lab.reduce((accu, curr) => {
    return accu + curr.mrp;
  }, 0);

  let hometotalData = home.reduce((accu, curr) => {
    return accu + curr.mrp;
  }, 0);

  const [selectedTab, setSelectedTab] = useState("lab");
  useEffect(() => {
    if (home.length === 0) {
      setSelectedTab("lab");
    } else {
      setSelectedTab("home");
    }
  }, []);
  const [formData, setFormData] = useState({});
  const [address, setAddress] = useState({
    buildingNumber: "",
    streetNumber: "",
    district: "",
    city: "",
    province: "",
    postalCode: "",
  });
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedLabDate, setSelectedLabDate] = useState(new Date());

  const today = new Date();
  const isPastDate = selectedDate < today;

  // cart details api
  useEffect(() => {
    const apiStatus = fetchTheCartApi(token);
    apiStatus
      .then((response) => {
        dispatch(setCartDataAction({ tests: response?.data?.data }));
        dispatch(setUserForTestTotalAmount(response?.data?.data?.total_amount));
      })
      .catch((err) => {
        console.log(err);
        dispatch(setAlert("error", err?.response?.data?.message));
      });
    // eslint-disable-next-line
  }, []);

  // slots detail api

  useEffect(() => {
    const debounce = setTimeout(() => {
      const apiStatus = fetchSlotApi(
        token,
        moment(selectedDate).format("DD-MM-YYYY")
      );
      apiStatus
        .then((response) => {
          if (response?.status === 200) {
            setinHouseSlotId(response.data.slots[0]._id);
            setTimeSlotData(response.data.slots[0].timeSlots);
            // dispatch(setAlert("success", response?.data?.message));
          } else {
            setinHouseSlotId("");
            setTimeSlotData([]);
            dispatch(setAlert("error", response?.response?.data?.message));
          }
        })
        .catch((err) => {
          console.log(err);
          setinHouseSlotId("");
          setTimeSlotData([]);
          dispatch(setAlert("error", err?.response?.data?.message));
        });
    }, 2000);

    return () => clearTimeout(debounce);
    // eslint-disable-next-line
  }, [selectedDate]);

  // slots detail api second
  useEffect(() => {
    const debounce = setTimeout(() => {
      const apiStatus = fetchSlotApi(
        token,
        moment(selectedLabDate).format("DD-MM-YYYY")
      );
      apiStatus
        .then((response) => {
          if (response?.status === 200) {
            setoutsourceSlotId(response.data.slots[0]._id);
            setTimeSlotData2(response.data.slots[0].timeSlots);
            // dispatch(setAlert("success", response?.data?.message));
          } else {
            setoutsourceSlotId("");
            setTimeSlotData2([]);
            dispatch(setAlert("error", response?.response?.data?.message));
          }
        })
        .catch((err) => {
          console.log(err);
          setoutsourceSlotId("");
          setTimeSlotData2([]);
          dispatch(setAlert("error", err?.response?.data?.message));
        });
    }, 2000);

    return () => clearTimeout(debounce);
    // eslint-disable-next-line
  }, [selectedLabDate]);

  // useEffect(() => {
  //   dispatch(setUserForTestTotalAmount(outSorcetotalData + hometotalData));
  // }, [home, lab]);

  const proceedFromFunction = async (data) => {
    try {
      const response = await proceedFromCart(token, data);
      if (response.status === 200) {
        // Check for successful response status
        navigate("/payment");
        dispatch(setOrderId(response?.data?.orderReferenceId));
      } else {
        dispatch(
          setAlert(
            "error",
            response?.response?.data?.error || response?.response?.data?.message
          )
        );
      }
    } catch (err) {
      console.log(err);
      dispatch(setAlert("error", err?.response?.data?.message));
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleAddress = (e) => {
    setAddress({ ...address, [e.target.name]: e.target.value });
  };



  const handleSubmit = (e) => {
    e?.preventDefault();
    e?.stopPropagation();
    setLoading(true); // Start loading
    formData.address = address;
    formData.inHouseSlotId = inHouseSlotId;
    formData.inHouseTimeId = selectedId;

    formData.outsourceSlotId = outsourceSlotId;
    formData.outsourceTimeId = selectedId2;
    formData.labId = "64ede9fddf3cf74618e7837d";
    delete formData.slot;

    if (lab?.length === 0) {
      // case of home address only

      if (selectedTab === "lab") {
        if (
          !formData?.location ||
          !formData?.labaddress ||
          !formData.outsourceSlotId ||
          !formData.outsourceTimeId
        ) {
          dispatch(setAlert("warning", "Please fill full lab details"));
          setLoading(false); // Stop loading
        } else {
          proceedFromFunction(formData).finally(() => setLoading(false));
        }
      } else {
        if (
          Object.values(formData?.address)?.includes("") ||
          !formData.inHouseSlotId ||
          !formData.inHouseTimeId
        ) {
          dispatch(setAlert("warning", "Please fill all address fields"));
          setLoading(false); // Stop loading
        } else {
          proceedFromFunction(formData).finally(() => setLoading(false));
        }
      }

    } else if (home?.length === 0) {
      console.log("lab only");
      // case of lab only

      if (
        !formData?.location ||
        !formData?.labaddress ||
        !formData.outsourceSlotId ||
        !formData.outsourceTimeId
      ) {
        dispatch(setAlert("warning", "Please fill full lab details"));
        setLoading(false); // Stop loading
      } else {
        proceedFromFunction(formData).finally(() => setLoading(false));
      }
    } else {
      // case of both home and lab
      console.log("both daat");
      if (
        !formData?.location ||
        !formData?.labaddress ||
        !formData.outsourceSlotId ||
        !formData.outsourceTimeId
      ) {
        dispatch(setAlert("warning", "All fields are required"));
        setLoading(false); // Stop loading
      } else {
        proceedFromFunction(formData).finally(() => setLoading(false));
      }
    }
  };

  // const proceedBtn = () => {
  //   navigate("/payment");
  // };

  const changeDate = (e) => {
    if (e <= today) {
      dispatch(setAlert("warning", "Please select upcoming date"));
    } else {
      setSelectedDate(e);
      setSelectedLabDate(e);
    }
  };

  function section1() {
    return (
      <>
        <div className="dot-wrapper">
          <div className="check">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
            >
              <path
                d="M5.33203 16.8148L11.8961 23.3333L26.6654 8.66666"
                stroke="white"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          <div className="line active"></div>

          <div className="dot">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="56"
              height="56"
              viewBox="0 0 56 56"
              fill="none"
            >
              <circle cx="28" cy="28" r="27.5" stroke="#F1BA6A" />
            </svg>
          </div>

          <div className="line"></div>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
          >
            <circle cx="28" cy="28" r="28" fill="#D9D9D9" />
          </svg>

          <BackButton path={"/cart"} />
        </div>

        <div className="tab">
          <div
            style={
              home && home.length !== 0 ? {} : { backgroundColor: "lightgray" }
            }
            className={(selectedTab === "home" && "active").toString()}
            onClick={() => {
              if (home && home.length !== 0) {
                setSelectedTab("home");
              }
              // setSelectedTab("home");
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="120"
              height="120"
              viewBox="0 0 120 120"
              fill="none"
            >
              <path
                d="M95.8033 40L75.8033 22.2C71.4581 18.3136 65.8329 16.1649 60.0033 16.1649C54.1736 16.1649 48.5484 18.3136 44.2033 22.2L24.2033 40C21.7005 42.23 19.6982 44.9646 18.328 48.0239C16.9578 51.0832 16.2507 54.3979 16.2533 57.75V89.5C16.2069 91.9987 16.6566 94.4818 17.5762 96.8056C18.4959 99.1293 19.8673 101.248 21.611 103.038C23.3548 104.828 25.4363 106.255 27.735 107.235C30.0338 108.216 32.5042 108.731 35.0033 108.75H85.0033C87.4853 108.73 89.9391 108.222 92.2246 107.254C94.5102 106.286 96.5827 104.877 98.3238 103.108C100.065 101.339 101.441 99.2448 102.372 96.9442C103.304 94.6436 103.773 92.182 103.753 89.7V57.95C103.778 54.5652 103.082 51.214 101.711 48.1191C100.34 45.0242 98.3263 42.2565 95.8033 40ZM71.2533 101.25H48.7533V85C48.7533 82.0163 49.9385 79.1548 52.0483 77.045C54.1581 74.9353 57.0196 73.75 60.0033 73.75C62.9869 73.75 65.8484 74.9353 67.9582 77.045C70.068 79.1548 71.2533 82.0163 71.2533 85V101.25ZM96.2533 89.7C96.2731 91.1971 95.9978 92.6834 95.4431 94.0742C94.8885 95.4649 94.0653 96.7327 93.0206 97.8052C91.9759 98.8778 90.7302 99.734 89.3546 100.325C87.979 100.916 86.5004 101.23 85.0033 101.25H78.7533V85C78.7533 80.0272 76.7778 75.258 73.2615 71.7417C69.7452 68.2254 64.9761 66.25 60.0033 66.25C55.0304 66.25 50.2613 68.2254 46.745 71.7417C43.2287 75.258 41.2533 80.0272 41.2533 85V101.25H35.0033C33.5061 101.23 32.0276 100.916 30.6519 100.325C29.2763 99.734 28.0306 98.8778 26.9859 97.8052C25.9412 96.7327 25.118 95.4649 24.5634 94.0742C24.0087 92.6834 23.7334 91.1971 23.7533 89.7V57.95C23.7584 55.6558 24.2463 53.3883 25.1853 51.295C26.1242 49.2017 27.4932 47.3295 29.2033 45.8L49.2033 28C52.1734 25.3434 56.0184 23.8748 60.0033 23.8748C63.9881 23.8748 67.8331 25.3434 70.8033 28L90.8033 45.8C92.5133 47.3295 93.8823 49.2017 94.8212 51.295C95.7602 53.3883 96.2481 55.6558 96.2533 57.95V89.7Z"
                fill="white"
              />
            </svg>

            <p>Home Sample Collection</p>
          </div>

          <div
            className={(selectedTab === "lab" && "active").toString()}
            onClick={() => setSelectedTab("lab")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="110"
              height="110"
              viewBox="0 0 110 110"
              fill="none"
            >
              <g clipPath="url(#clip0_538_6219)">
                <path
                  d="M109.021 99.4984H103.607V32.2094H107.045C107.268 32.2094 107.482 32.1207 107.64 31.9627C107.798 31.8048 107.887 31.5906 107.887 31.3672V23.6328C107.889 23.5208 107.869 23.4094 107.828 23.3052C107.786 23.2011 107.725 23.1062 107.646 23.0262C107.568 22.9461 107.474 22.8826 107.371 22.8392C107.268 22.7958 107.157 22.7734 107.045 22.7734H81.5211V10.7422H86.6773C86.7894 10.7422 86.9003 10.7199 87.0037 10.6765C87.107 10.6331 87.2006 10.5695 87.279 10.4895C87.3575 10.4094 87.4191 10.3146 87.4604 10.2104C87.5017 10.1062 87.5218 9.99486 87.5195 9.88282V0.842195C87.5196 0.730136 87.4972 0.619199 87.4538 0.515884C87.4104 0.412568 87.3468 0.318952 87.2668 0.240519C87.1868 0.162085 87.0919 0.100413 86.9877 0.059114C86.8836 0.0178152 86.7722 -0.00227935 86.6602 7.567e-06H23.5477C23.4356 -0.00227935 23.3243 0.0178152 23.2201 0.059114C23.1159 0.100413 23.021 0.162085 22.941 0.240519C22.861 0.318952 22.7974 0.412568 22.754 0.515884C22.7106 0.619199 22.6883 0.730136 22.6883 0.842195V9.90001C22.6883 10.1279 22.7788 10.3465 22.94 10.5077C23.1012 10.6688 23.3197 10.7594 23.5477 10.7594H28.7039V22.7906H3.19766C3.0856 22.7906 2.97466 22.813 2.87135 22.8563C2.76803 22.8997 2.67441 22.9633 2.59598 23.0433C2.51755 23.1234 2.45587 23.2183 2.41458 23.3224C2.37328 23.4266 2.35318 23.538 2.35547 23.65V31.3844C2.35547 31.6077 2.4442 31.822 2.60214 31.9799C2.76008 32.1378 2.97429 32.2266 3.19766 32.2266H6.63516V99.4984H0.963281C0.739919 99.4984 0.525706 99.5872 0.367765 99.7451C0.209824 99.9031 0.121094 100.117 0.121094 100.341V109.158C0.121094 109.381 0.209824 109.595 0.367765 109.753C0.525706 109.911 0.739919 110 0.963281 110H109.021C109.133 110.002 109.244 109.982 109.349 109.941C109.453 109.9 109.548 109.838 109.628 109.759C109.708 109.681 109.771 109.587 109.815 109.484C109.858 109.381 109.88 109.27 109.88 109.158V100.341C109.88 100.229 109.858 100.118 109.815 100.014C109.771 99.911 109.708 99.8174 109.628 99.739C109.548 99.6605 109.453 99.5989 109.349 99.5576C109.244 99.5163 109.133 99.4962 109.021 99.4984ZM101.905 99.4984H81.5211V32.2094H101.905V99.4984ZM79.8195 10.7594V99.4984H71.0023V75.8828C71.0023 75.6595 70.9136 75.4452 70.7557 75.2873C70.5977 75.1294 70.3835 75.0406 70.1602 75.0406H40.2539C40.0305 75.0406 39.8163 75.1294 39.6584 75.2873C39.5004 75.4452 39.4117 75.6595 39.4117 75.8828V99.4984H30.3711V10.7594H79.8195ZM8.28516 32.2094H28.6867V99.4984H8.28516V32.2094Z"
                  fill="#2A364E"
                />
                <path
                  d="M22.4656 35.6125H14.4047C13.9396 35.6125 13.5625 35.9896 13.5625 36.4547V44.4984C13.5625 44.9636 13.9396 45.3406 14.4047 45.3406H22.4656C22.9308 45.3406 23.3078 44.9636 23.3078 44.4984V36.4547C23.3078 35.9896 22.9308 35.6125 22.4656 35.6125Z"
                  fill="#2A364E"
                />
                <path
                  d="M22.4656 52.2672H14.4047C13.9396 52.2672 13.5625 52.6442 13.5625 53.1094V61.1531C13.5625 61.6182 13.9396 61.9953 14.4047 61.9953H22.4656C22.9308 61.9953 23.3078 61.6182 23.3078 61.1531V53.1094C23.3078 52.6442 22.9308 52.2672 22.4656 52.2672Z"
                  fill="#2A364E"
                />
                <path
                  d="M22.4658 67.0313H14.4049C14.1815 67.0313 13.9673 67.12 13.8093 67.2779C13.6514 67.4359 13.5627 67.6501 13.5627 67.8734V75.9172C13.5604 76.0292 13.5805 76.1406 13.6218 76.2448C13.6631 76.3489 13.7248 76.4438 13.8032 76.5238C13.8816 76.6039 13.9752 76.6675 14.0786 76.7109C14.1819 76.7542 14.2928 76.7766 14.4049 76.7766H22.4658C22.5779 76.7766 22.6888 76.7542 22.7921 76.7109C22.8954 76.6675 22.989 76.6039 23.0675 76.5238C23.1459 76.4438 23.2076 76.3489 23.2489 76.2448C23.2902 76.1406 23.3103 76.0292 23.308 75.9172V67.8391C23.2991 67.6217 23.2065 67.4162 23.0495 67.2656C22.8925 67.1151 22.6833 67.0311 22.4658 67.0313ZM22.4658 81.7266H14.4049C14.2928 81.7265 14.1819 81.7489 14.0786 81.7923C13.9752 81.8357 13.8816 81.8993 13.8032 81.9793C13.7248 82.0593 13.6631 82.1542 13.6218 82.2584C13.5805 82.3625 13.5604 82.4739 13.5627 82.5859V90.6297C13.5627 90.8531 13.6514 91.0673 13.8093 91.2252C13.9673 91.3831 14.1815 91.4719 14.4049 91.4719H22.4658C22.5764 91.4719 22.6859 91.4501 22.7881 91.4078C22.8903 91.3654 22.9831 91.3034 23.0613 91.2252C23.1395 91.147 23.2016 91.0542 23.2439 90.952C23.2862 90.8498 23.308 90.7403 23.308 90.6297V82.5859C23.3103 82.4739 23.2902 82.3625 23.2489 82.2584C23.2076 82.1542 23.1459 82.0593 23.0675 81.9793C22.989 81.8993 22.8954 81.8357 22.7921 81.7923C22.6888 81.7489 22.5779 81.7265 22.4658 81.7266ZM87.7439 45.3406H95.7877C96.0126 45.3407 96.2287 45.2525 96.3893 45.095C96.55 44.9376 96.6425 44.7234 96.647 44.4984V36.4547C96.6425 36.2298 96.55 36.0156 96.3893 35.8581C96.2287 35.7006 96.0126 35.6125 95.7877 35.6125H87.7439C87.6333 35.6125 87.5238 35.6343 87.4216 35.6766C87.3195 35.7189 87.2266 35.781 87.1484 35.8592C87.0702 35.9374 87.0082 36.0302 86.9658 36.1324C86.9235 36.2346 86.9017 36.3441 86.9017 36.4547V44.4984C86.9017 44.609 86.9235 44.7186 86.9658 44.8207C87.0082 44.9229 87.0702 45.0158 87.1484 45.094C87.2266 45.1722 87.3195 45.2342 87.4216 45.2765C87.5238 45.3188 87.6333 45.3406 87.7439 45.3406ZM87.7439 61.9953H95.7877C96.0126 61.9954 96.2287 61.9072 96.3893 61.7497C96.55 61.5923 96.6425 61.3781 96.647 61.1531V53.1094C96.6425 52.8844 96.55 52.6703 96.3893 52.5128C96.2287 52.3553 96.0126 52.2671 95.7877 52.2672H87.7439C87.6333 52.2672 87.5238 52.289 87.4216 52.3313C87.3195 52.3736 87.2266 52.4357 87.1484 52.5139C87.0702 52.5921 87.0082 52.6849 86.9658 52.7871C86.9235 52.8893 86.9017 52.9988 86.9017 53.1094V61.1531C86.9017 61.2637 86.9235 61.3732 86.9658 61.4754C87.0082 61.5776 87.0702 61.6704 87.1484 61.7486C87.2266 61.8269 87.3195 61.8889 87.4216 61.9312C87.5238 61.9735 87.6333 61.9953 87.7439 61.9953ZM87.7439 76.7422H95.7877C96.0156 76.7422 96.2342 76.6517 96.3953 76.4905C96.5565 76.3293 96.647 76.1107 96.647 75.8828V67.8391C96.6425 67.6141 96.55 67.3999 96.3893 67.2425C96.2287 67.085 96.0126 66.9968 95.7877 66.9969H87.7439C87.6333 66.9969 87.5238 67.0187 87.4216 67.061C87.3195 67.1033 87.2266 67.1653 87.1484 67.2435C87.0702 67.3218 87.0082 67.4146 86.9658 67.5168C86.9235 67.619 86.9017 67.7285 86.9017 67.8391V75.8828C86.8995 75.9949 86.9195 76.1062 86.9608 76.2104C87.0021 76.3146 87.0638 76.4094 87.1422 76.4895C87.2207 76.5695 87.3143 76.6331 87.4176 76.6765C87.5209 76.7199 87.6319 76.7422 87.7439 76.7422ZM87.7439 91.4719H95.7877C96.0126 91.4719 96.2287 91.3837 96.3893 91.2263C96.55 91.0688 96.6425 90.8546 96.647 90.6297V82.5859C96.647 82.358 96.5565 82.1394 96.3953 81.9783C96.2342 81.8171 96.0156 81.7266 95.7877 81.7266H87.7439C87.6319 81.7265 87.5209 81.7489 87.4176 81.7923C87.3143 81.8357 87.2207 81.8993 87.1422 81.9793C87.0638 82.0593 87.0021 82.1542 86.9608 82.2584C86.9195 82.3625 86.8995 82.4739 86.9017 82.5859V90.6297C86.9017 90.7403 86.9235 90.8498 86.9658 90.952C87.0082 91.0542 87.0702 91.147 87.1484 91.2252C87.2266 91.3034 87.3195 91.3654 87.4216 91.4078C87.5238 91.4501 87.6333 91.4719 87.7439 91.4719ZM38.3986 68.1141H71.7939C72.3658 68.1121 72.9274 67.9623 73.4243 67.6792C73.9212 67.3961 74.3365 66.9893 74.6299 66.4984C74.9452 66.0025 75.1282 65.4341 75.1613 64.8473C75.1944 64.2605 75.0765 63.6751 74.8189 63.1469L61.4127 36.0938V21.6219C62.1849 21.3866 62.8497 20.8871 63.2905 20.2109C63.7314 19.5346 63.9202 18.7248 63.8238 17.9233C63.7275 17.1219 63.3521 16.3799 62.7636 15.8274C62.175 15.2749 61.4108 14.9471 60.6049 14.9016H49.433C48.6322 14.9475 47.8726 15.272 47.2859 15.8189C46.6991 16.3658 46.3221 17.1007 46.2201 17.8963C46.1181 18.6919 46.2975 19.4982 46.7273 20.1754C47.1572 20.8526 47.8103 21.3583 48.5736 21.6047V36.3516L46.6314 40.3047L35.3908 63.1469C35.1173 63.6859 34.9908 64.2875 35.024 64.891C35.0572 65.4945 35.2489 66.0786 35.5799 66.5844C35.8832 67.0557 36.3006 67.443 36.7933 67.7104C37.2859 67.9777 37.8381 68.1166 38.3986 68.1141ZM48.0236 58.2484C48.0202 57.5067 48.2371 56.7806 48.6467 56.1621C49.0563 55.5437 49.6403 55.0608 50.3247 54.7746C51.009 54.4883 51.7629 54.4117 52.4909 54.5543C53.2188 54.6969 53.8881 55.0524 54.4138 55.5757C54.9395 56.099 55.2981 56.7666 55.4441 57.4939C55.59 58.2212 55.5168 58.9755 55.2338 59.6611C54.9507 60.3468 54.4705 60.933 53.8539 61.3455C53.2374 61.7579 52.5123 61.9781 51.7705 61.9781C50.7797 61.9781 49.8293 61.5857 49.1271 60.8868C48.4249 60.1878 48.0282 59.2392 48.0236 58.2484ZM60.708 61.9781C60.0954 61.9781 59.4965 61.7962 58.9874 61.4555C58.4783 61.1148 58.0818 60.6306 57.8481 60.0643C57.6145 59.498 57.5542 58.8751 57.675 58.2745C57.7958 57.6739 58.0921 57.1227 58.5265 56.6907C58.9609 56.2587 59.5138 55.9654 60.115 55.848C60.7163 55.7306 61.3389 55.7943 61.9039 56.0311C62.4689 56.2679 62.9508 56.6671 63.2887 57.1781C63.6266 57.6891 63.8051 58.289 63.8017 58.9016C63.7972 59.7191 63.4692 60.5016 62.8895 61.0781C62.3098 61.6546 61.5255 61.9781 60.708 61.9781ZM56.9611 49.9469C56.9611 49.335 57.1426 48.7368 57.4825 48.2281C57.8224 47.7193 58.3056 47.3228 58.8709 47.0886C59.4362 46.8545 60.0583 46.7932 60.6584 46.9126C61.2586 47.0319 61.8098 47.3266 62.2425 47.7593C62.6751 48.1919 62.9698 48.7432 63.0892 49.3433C63.2085 49.9434 63.1473 50.5655 62.9131 51.1308C62.679 51.6961 62.2824 52.1793 61.7737 52.5192C61.2649 52.8592 60.6667 53.0406 60.0549 53.0406C59.2432 53.0407 58.464 52.7219 57.8853 52.1528C57.3065 51.5837 56.9746 50.81 56.9611 49.9984V49.9469ZM50.1892 36.8844C50.2419 36.765 50.2711 36.6366 50.2752 36.5063V21.725H59.7283V36.3344C59.6944 36.4523 59.6944 36.5774 59.7283 36.6953L61.1892 39.6516C60.265 39.3643 59.2881 39.2878 58.3304 39.4276C57.3727 39.5674 56.4585 39.9199 55.6549 40.4594C54.9225 40.9514 54.1158 41.3228 53.2658 41.5594C52.4292 41.87 51.5233 41.9446 50.6472 41.7748C49.7711 41.605 48.9586 41.1975 48.2986 40.5969L50.1892 36.8844Z"
                  fill="#2A364E"
                />
                <path
                  d="M60.7047 60.2937C61.4736 60.2937 62.0969 59.6704 62.0969 58.9016C62.0969 58.1327 61.4736 57.5094 60.7047 57.5094C59.9358 57.5094 59.3125 58.1327 59.3125 58.9016C59.3125 59.6704 59.9358 60.2937 60.7047 60.2937Z"
                  fill="#2A364E"
                />
                <path
                  d="M60.0539 51.3906C60.3285 51.3872 60.596 51.3027 60.8226 51.1477C61.0493 50.9927 61.2251 50.7741 61.3278 50.5194C61.4305 50.2647 61.4557 49.9854 61.4 49.7165C61.3444 49.4475 61.2105 49.2011 61.0151 49.0081C60.8197 48.8151 60.5716 48.6842 60.3021 48.6319C60.0325 48.5795 59.7534 48.6081 59.5001 48.7139C59.2467 48.8198 59.0302 48.9982 58.878 49.2268C58.7258 49.4554 58.6446 49.7238 58.6445 49.9984C58.6445 50.1827 58.6811 50.3652 58.7521 50.5352C58.8232 50.7052 58.9272 50.8595 59.0584 50.989C59.1895 51.1185 59.345 51.2207 59.5159 51.2896C59.6868 51.3586 59.8696 51.3929 60.0539 51.3906Z"
                  fill="#2A364E"
                />
                <path
                  d="M51.768 60.2938C52.8976 60.2938 53.8133 59.378 53.8133 58.2484C53.8133 57.1188 52.8976 56.2031 51.768 56.2031C50.6384 56.2031 49.7227 57.1188 49.7227 58.2484C49.7227 59.378 50.6384 60.2938 51.768 60.2938Z"
                  fill="#2A364E"
                />
              </g>
              <defs>
                <clipPath id="clip0_538_6219">
                  <rect width="110" height="110" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <p>Walk-In for Lab Test</p>
          </div>
        </div>

        {selectedTab === "home" ? (
          <>
            <h4>Sample collection Address</h4>

            <form
              id="address-form"
              className="input-wrapper"
              onSubmit={(e) => handleSubmit(e)}
            >
              <div>
                <p>House/Building Number</p>
                <input
                  type="text"
                  placeholder="Enter House Number"
                  name="buildingNumber"
                  onChange={(e) => handleAddress(e)}
                />
              </div>
              <div>
                <p>Street Name</p>
                <input
                  type="text"
                  placeholder="Enter Street Name"
                  name="streetNumber"
                  onChange={(e) => handleAddress(e)}
                />
              </div>
              <div>
                <p>Barangay/District</p>
                <input
                  type="text"
                  placeholder="Enter District Name"
                  name="district"
                  onChange={(e) => handleAddress(e)}
                />
              </div>
              <div>
                <p>City/Municipality</p>
                <input
                  type="text"
                  placeholder="Enter City Name"
                  name="city"
                  onChange={(e) => handleAddress(e)}
                />
              </div>
              <div>
                <p>Province</p>
                <input
                  type="text"
                  placeholder="Enter Province"
                  name="province"
                  onChange={(e) => handleAddress(e)}
                />
              </div>
              <div>
                <p>Postal Code</p>
                <input
                  type="number"
                  placeholder="Enter Postal Code"
                  name="postalCode"
                  onChange={(e) => handleAddress(e)}
                />
              </div>
            </form>

            <div>
              <div className="price">
                <h4>Total Amount : ₱{outSorcetotalData + hometotalData}</h4>
              </div>

              {home && home.length > 0 ? (
                home.map((curr, idx) => {
                  return <SelectedTest data={curr} key={idx} />;
                })
              ) : (
                <div className="no-data-found" style={{ height: "75px" }}>
                  No Tests Found
                </div>
              )}
            </div>

            <h4 style={{ marginTop: "50px" }}>
              Select time slot for home sample collection
            </h4>

            <div className="slots">
              <div className="calendar">
                <Calendar value={selectedDate} onChange={changeDate} />
              </div>
              {/* {isDateInPast ? (
        <h1>Please select a future date</h1>
      ) : ( */}
              <div className="slots-parent">
                <div className="slots-wrapper">
                  {timeSlotData?.length > 0 &&
                    timeSlotData?.map((item, i) => (
                      <div
                        onClick={() => {
                          setSelectedId(item._id);
                          setFormData({
                            ...formData,
                            slot: item._id,
                          });
                        }}
                        className={`${item.status == "Almost Filled" &&
                            item._id != selectedId
                            ? "almost-filled"
                            : item.status == "Fast Filling"
                              ? "fast-filling"
                              : item.status == "Not Available"
                                ? "not-available"
                                : item._id == selectedId
                                  ? "selected"
                                  : ""
                          }`}
                      >
                        {`${item?.startTime} To ${item?.endTime}`}
                      </div>
                    ))}
                </div>

                <div className="slots-type">
                  <p>
                    <span style={{ background: "#D9D9D9" }}></span>Not Available
                  </p>
                  <p>
                    <span style={{ background: "#F1BA6A" }}></span>Almost Filled
                  </p>
                  <p>
                    <span style={{ background: "#A61F23" }}></span>Fast Filling
                  </p>
                  <p>
                    <span
                      style={{ background: "#FFF", border: "solid 1px black" }}
                    ></span>
                    Available
                  </p>
                  <p>
                    <span style={{ background: "#3AA1ED" }}></span>Selected
                  </p>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            {/* {lab?.length === 0 ? null  */}
            {/* <h4
              style={{
                borderTop: "solid 4px #cacdd2",
                paddingTop: "40px",
                paddingBottom: "15px",
              }}
            >
              Sample collection is not acceptable for these tests
            </h4> */}
            <div className="price">
              <h4>Total Amount : ₱{outSorcetotalData + hometotalData}</h4>
            </div>
          </>
        )}

        {selectedTab === "home" && lab?.length === 0 ? null : (
          <>
            <div>
              {selectedTab === "lab" && home && home.length > 0
                ? home.map((curr, idx) => {
                  return <SelectedTest data={curr} key={idx} />;
                })
                : null}

              {lab && lab.length > 0 ? (
                lab.map((curr, idx) => {
                  return <SelectedTest data={curr} key={idx} />;
                })
              ) : (
                <div className="no-data-found" style={{ height: "75px" }}>
                  {/* No Tests Found */}
                </div>
              )}
            </div>

            <h6>Please select the test location where you will go for test</h6>

            <div className="lab-wrapper">
              <div className="location">
                <label>Select Location</label>
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M19.2785 6.34001C18.8149 5.4544 18.1761 4.67236 17.4007 4.04144C16.6254 3.41052 15.7298 2.94392 14.7685 2.67001C13.8676 2.40898 12.9363 2.26777 11.9985 2.25001C11.1029 2.24898 10.2114 2.37009 9.3485 2.61001C8.37518 2.88075 7.46802 3.34897 6.68351 3.98553C5.899 4.62208 5.25394 5.41333 4.7885 6.31001C4.27786 7.28068 3.97019 8.34515 3.88423 9.43857C3.79827 10.532 3.93582 11.6315 4.2885 12.67C5.33644 15.7469 7.12576 18.5184 9.4985 20.74C10.1731 21.3808 11.068 21.7381 11.9985 21.7381C12.929 21.7381 13.8239 21.3808 14.4985 20.74C16.8852 18.5024 18.6818 15.7096 19.7285 12.61C20.0807 11.5887 20.2225 10.5066 20.1451 9.42896C20.0678 8.35135 19.773 7.30057 19.2785 6.34001ZM18.2785 12.19C17.3073 15.0369 15.6522 17.6019 13.4585 19.66C13.0635 20.0401 12.5367 20.2524 11.9885 20.2524C11.4403 20.2524 10.9135 20.0401 10.5185 19.66C8.3077 17.5766 6.64522 14.9799 5.6785 12.1C5.39932 11.265 5.29433 10.3816 5.37001 9.50441C5.44568 8.62722 5.70043 7.77487 6.1185 7.00001C6.48417 6.2768 6.99538 5.63699 7.62005 5.12073C8.24472 4.60448 8.96937 4.22292 9.7485 4.00001C10.4841 3.81708 11.2407 3.733 11.9985 3.75001C12.798 3.76899 13.5915 3.89339 14.3585 4.12001C15.1306 4.32411 15.8523 4.6852 16.4786 5.18073C17.1049 5.67625 17.6223 6.29557 17.9985 7.00001C18.3956 7.80042 18.6261 8.67313 18.676 9.56525C18.7258 10.4574 18.594 11.3503 18.2885 12.19H18.2785Z"
                      fill="black"
                    />
                    <path
                      d="M12 6.25C11.2583 6.25 10.5333 6.46993 9.91661 6.88199C9.29993 7.29404 8.81928 7.87971 8.53545 8.56494C8.25163 9.25016 8.17736 10.0042 8.32206 10.7316C8.46675 11.459 8.8239 12.1272 9.34835 12.6517C9.8728 13.1761 10.541 13.5333 11.2684 13.6779C11.9958 13.8226 12.7498 13.7484 13.4351 13.4645C14.1203 13.1807 14.706 12.7001 15.118 12.0834C15.5301 11.4667 15.75 10.7417 15.75 10C15.75 9.00544 15.3549 8.05161 14.6517 7.34835C13.9484 6.64509 12.9946 6.25 12 6.25ZM12 12.25C11.555 12.25 11.12 12.118 10.75 11.8708C10.38 11.6236 10.0916 11.2722 9.92127 10.861C9.75098 10.4499 9.70642 9.9975 9.79323 9.56105C9.88005 9.12459 10.0943 8.72368 10.409 8.40901C10.7237 8.09434 11.1246 7.88005 11.561 7.79323C11.9975 7.70642 12.4499 7.75097 12.861 7.92127C13.2722 8.09157 13.6236 8.37996 13.8708 8.74997C14.118 9.11998 14.25 9.55499 14.25 10C14.25 10.5967 14.0129 11.169 13.591 11.591C13.169 12.0129 12.5967 12.25 12 12.25Z"
                      fill="black"
                    />
                  </svg>

                  <select
                    name="location"
                    defaultValue={"none"}
                    onChange={(e) => handleChange(e)}
                  >
                    <option hidden value="none">
                      Choose Location
                    </option>
                    <option value="Quezon">Quezon</option>
                  </select>
                </div>
              </div>
              <div>
                <label>Select Lab</label>
                <div>
                  <select
                    name="labaddress"
                    defaultValue={"none"}
                    onChange={(e) => handleChange(e)}
                  >
                    <option hidden value="none">
                      Choose Lab
                    </option>
                    <option value="Quezon City">Quezon City</option>
                  </select>
                </div>
              </div>
            </div>

            <h4 style={{ marginTop: "50px" }}>
              Select time slot to visit lab for giving sample
            </h4>

            <div className="slots">
              <div className="calendar">
                <Calendar value={selectedLabDate} onChange={changeDate} />
              </div>
              <div className="slots-parent">
                <div className="slots-wrapper">
                  {timeSlotData2?.length > 0 &&
                    timeSlotData2?.map((item, i) => (
                      <div
                        onClick={() => {
                          setSelectedId2(item._id);
                          setFormData({
                            ...formData,
                            slot: item._id,
                          });
                        }}
                        className={`${item.status == "Almost Filled" &&
                            item._id != selectedId2
                            ? "almost-filled"
                            : item.status == "Fast Filling" &&
                              item._id != selectedId2
                              ? "fast-filling"
                              : item.status == "Not Available"
                                ? "not-available"
                                : item._id == selectedId2
                                  ? "selected"
                                  : ""
                          }`}
                      >
                        {`${item?.startTime} To ${item?.endTime}`}
                      </div>
                    ))}
                </div>
                <div className="slots-type">
                  <p>
                    <span style={{ background: "#D9D9D9" }}></span>Not Available
                  </p>
                  <p>
                    <span style={{ background: "#F1BA6A" }}></span>Almost Filled
                  </p>
                  <p>
                    <span style={{ background: "#A61F23" }}></span>Fast Filling
                  </p>
                  <p>
                    <span
                      style={{ background: "#FFF", border: "solid 1px black" }}
                    ></span>
                    Available
                  </p>
                  <p>
                    <span style={{ background: "#3AA1ED" }}></span>Selected
                  </p>
                </div>
              </div>
            </div>
          </>
        )}

        <button
          onClick={(e) => handleSubmit(e)}
          form="address-form"
          type="submit"
          disabled={loading}
        >
          {loading ? <span className="loader"></span> : "Proceed"}
        </button>
      </>
    );
  }

  return (
    <div className="cart-page">
      <Header />

      <div className="section-1">{section1()}</div>

      <Footer />
    </div>
  );
};

export default CollectionLocation;
